// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPharmacyGroupDrugsInStore,
  selectPharmacyGroupDrugsPageLoading,
  selectPharmacyGroupDrugsShowInitWaitingMessage,
} from '../_selectors/pharmacy-group-drug.selectors';

export class PharmacyGroupDrugsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPharmacyGroupDrugsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectPharmacyGroupDrugsShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectPharmacyGroupDrugsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
